// These durations are in milliseconds
export const NotificationDuration = {
  DEFAULT: 5000,
};
